// Target Geometry and Logic

export const TARGET_DIMS = {
    width: 220, // 260 - 40
    height: 410, // 450 - 40
    centerX: 150,
    centerY: 245 // Approx mid
};

// Check score for a point relative to the target's origin
// Input x,y are relative to the viewbox 0,0 defined in the path.

export const getZoneScore = (x, y) => {
    // Top Zone A: X 130-170, Y 60-100 (Box) => 5 pts
    if (x >= 130 && x <= 170 && y >= 60 && y <= 100) return 5;

    // Center Zone A: X 110-190, Y 180-330 => 5 pts
    if (x >= 110 && x <= 190 && y >= 180 && y <= 330) return 5;

    // Zone B: X 110-190, Y 40-120
    if (x >= 110 && x <= 190 && y >= 40 && y <= 120) return 3;

    // Zone C: X 70-230, Y 150-420.
    if (x >= 70 && x <= 230 && y >= 150 && y <= 420) return 3;

    // Zone D: Rest of Body. X 40-260, Y 120-450.
    if (x >= 40 && x <= 260 && y >= 120 && y <= 450) return 1;

    return 0; // Miss
};

// Helper to draw on Canvas
export const drawTargetCanvas = (ctx, x, y, scale = 1, rotation = 0, fillColor = "#cda46a") => {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.scale(scale, scale);

    // Centering logic
    ctx.translate(-150, -245);

    // Path
    ctx.beginPath();
    ctx.moveTo(110, 40);
    ctx.lineTo(190, 40);
    ctx.lineTo(190, 120);
    ctx.lineTo(260, 120);
    ctx.lineTo(260, 450);
    ctx.lineTo(40, 450);
    ctx.lineTo(40, 120);
    ctx.lineTo(110, 120);
    ctx.closePath();
    ctx.fillStyle = fillColor;
    ctx.fill();
    ctx.lineWidth = 3;
    ctx.strokeStyle = "#000";
    ctx.stroke();

    // Zones (Dashed Lines)
    ctx.lineWidth = 1;
    ctx.strokeStyle = "rgba(0,0,0,0.3)";
    ctx.setLineDash([5, 5]);

    // Zone A (Top)
    ctx.strokeRect(130, 60, 40, 40);

    // Zone A (Center)
    ctx.strokeRect(110, 180, 80, 150);

    // Zone C
    if (ctx.roundRect) {
        ctx.beginPath();
        ctx.roundRect(70, 150, 160, 270, 10);
        ctx.stroke();
    } else {
        ctx.strokeRect(70, 150, 160, 270);
    }

    ctx.restore();
};

// Hit Test Helper for Canvas
export const checkHitCanvas = (clickX, clickY, targetX, targetY, scale = 1, rotation = 0) => {
    let dx = clickX - targetX;
    let dy = clickY - targetY;

    const cos = Math.cos(-rotation);
    const sin = Math.sin(-rotation);
    const rx = dx * cos - dy * sin;
    const ry = dx * sin + dy * cos;

    const lx = rx / scale;
    const ly = ry / scale;

    const svgX = lx + 150;
    const svgY = ly + 245;

    return getZoneScore(svgX, svgY);
};
